// Rojkird.jsx (UPDATED with i18n keys: "Rojkird")
// ✅ Only text replaced by t(...). Logic/style kept same.

import React, { useEffect, useRef, useState } from "react";
import "./Rojkird.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import back from "../../imgs/backexam.png";
import { useTranslation } from "react-i18next";

const Rojkird = (props) => {
  const { t } = useTranslation();

  const [input, setInput] = useState({
    date1: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    kno: "",
    kname: "",
    lastkhadya: "",
    lastadv: "",
    lastdate: "",
    dno: "",
    name: "",
    khname: "",
    searchsank: "",
  });

  const inputRefs = useRef([]);
  const [DataSource, setDataSource] = useState([]);
  const [tableFilter, setTableFilter] = useState([]);
  const [value, setValue] = useState("");
  const [wait, setWait] = useState(false);

  // kept (even if not used elsewhere)
  const [khrtype, setKhrtype] = useState("khpur");
  const refprint = useRef(null);
  const refprintclose = useRef(null);
  const navigate = useNavigate();

  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);

  const handlertype = (type) => {
    setKhrtype(type);
  };

  useEffect(() => {
    setDataSource([]);
  }, [khrtype]);

  const handleprintclose = () => {
    if (refprintclose.current) refprintclose.current.click();
  };

  useEffect(() => {
    setInput((prevInput) => ({
      ...prevInput,
      date2: input.date1,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.date1]);

  function handleEnterKey(event, currentIndex) {
    if (event.keyCode === 8) {
      if (event.target.name === "time") {
        setInput((prev) => ({ ...prev, time: "" }));
      } else if (event.target.name === "type") {
        setInput((prev) => ({ ...prev, type: "" }));
      }
    }

    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();
      let nextIndex = null;

      if (currentIndex === 2) {
        nextIndex = input.name !== "" ? currentIndex + 1 : currentIndex;
      } else {
        nextIndex = currentIndex + 1;
      }

      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }
  }

  const filteData = (e) => {
    const searchValue = e.target.value.trim();

    if (searchValue !== "") {
      setValue(searchValue);
      const filtertable = DataSource.filter((o) => String(o.kno) === searchValue);
      setTableFilter([...filtertable]);
    } else {
      setValue(searchValue);
      setTableFilter([...DataSource]);
    }
  };

  const showprint = () => {
    if (DataSource && DataSource.length > 0) {
      localStorage.setItem("date1print", input.date1);
      localStorage.setItem("date2print", input.date2);

      const url = "/rojkirdprint";
      window.open(url, "_blank");
    } else {
      notifyerror(t("Rojkird.toast.noDataForPeriod"));
    }
  };

  const handleChange = async (event) => {
    const name = event.target.name;
    const valuecurrent = event.target.value;

    setInput((v) => ({ ...v, [name]: valuecurrent }));

    if (name === "date2") {
      const date1 = new Date(input.date1);
      const date2 = new Date(valuecurrent);
      const differenceInDays = (date2 - date1) / (1000 * 60 * 60 * 24);

      if (differenceInDays <= 30) {
        setInput((prev) => ({ ...prev, [name]: valuecurrent }));
      } else {
        notifyerror(t("Rojkird.toast.reportLimitOneMonth"));
        setInput((prev) => ({ ...prev, [name]: new Date().toISOString().substr(0, 10) }));
      }
    }
  };

  const getrojkird = () => {
    setValue("");
    setWait(true);

    var mainuser2 = jsEncode.encode("mamapr", 125);
    const landingphp = "getrojkird2.php";

    let rawData = {
      date1: input.date1,
      date2: input.date2,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    };

    rawData = JSON.stringify(rawData);

    let formData = new FormData();
    formData.append("data", rawData);

    axios
      .post(`https://excellentdairy.com/dairy/php/cust/${landingphp}`, formData, {
        "Content-Type": "multipart/form-data",
      })
      .then(function sample(response) {
        if (response.data && response.data.length > 0) {
          setDataSource(response.data);
          setWait(false);
        } else {
          notifyerror(t("Rojkird.toast.noData"));
          setDataSource([]);
          setWait(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setWait(false);
      });
  };

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    },
  };

  function groupByHead(data, isPositive = true) {
    return data.reduce((acc, row) => {
      const head = isPositive ? row.positive_head : row.negative_head;
      if (!head) return acc;
      if (!acc[head]) {
        acc[head] = { total: 0, records: [] };
      }
      const amt = isPositive ? parseFloat(row.positive_amount || 0) : parseFloat(row.negative_amount || 0);
      acc[head].total += amt;
      acc[head].records.push(row);
      return acc;
    }, {});
  }

  function toGroupArray(groupedObj) {
    return Object.entries(groupedObj).map(([head, info]) => ({
      head,
      total: info.total,
      records: info.records,
    }));
  }

  const sourceData = DataSource;
  const posDict = groupByHead(sourceData, true);
  const negDict = groupByHead(sourceData, false);
  const posGroups = toGroupArray(posDict);
  const negGroups = toGroupArray(negDict);

  const posRows = posGroups.reduce((sum, group) => sum + group.records.length + 1, 0);
  const negRows = negGroups.reduce((sum, group) => sum + group.records.length + 1, 0);
  const maxRows = Math.max(posRows, negRows);

  function addBlankRows(groups, totalRows) {
    let currentRows = groups.reduce((sum, group) => sum + group.records.length + 1, 0);
    let blanksNeeded = totalRows - currentRows;

    if (blanksNeeded > 0) {
      groups.push({
        head: "",
        total: 0,
        records: new Array(blanksNeeded).fill({ positive_kno: "", positive_name: "", positive_amount: "" }),
      });
    }
    return groups;
  }

  const posGroupsFilled = addBlankRows([...posGroups], maxRows);
  const negGroupsFilled = addBlankRows([...negGroups], maxRows);

  const grandPosTotal = sourceData.reduce((sum, row) => sum + parseFloat(row.positive_amount || 0), 0);
  const grandNegTotal = sourceData.reduce((sum, row) => sum + parseFloat(row.negative_amount || 0), 0);

  const grandOpeningTotal = sourceData.reduce((sum, row) => parseFloat(row.opening_balance || 0), 0);
  const grandClosingTotal = sourceData.reduce((sum, row) => parseFloat(row.closing_balance || 0), 0);

  useEffect(() => {
    if (input.dno === "") {
      setInput((prev) => ({ ...prev, name: "" }));
    } else {
      let custlisttemp = JSON.parse(localStorage.getItem("auditlist"));
      for (let i = 0; i < custlisttemp.length; i++) {
        setInput((prev) => ({ ...prev, name: "" }));
        const user = custlisttemp[i];
        if (user.kno === input.dno) {
          setInput((prev) => ({ ...prev, name: user.name }));
          break;
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.dno]);

  return (
    <>
      <ToastContainer />

      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden={true}
        ref={refprint}
        data-bs-target="#printinput"
      ></button>

      <div className="sanklanmain">
        <div className="firstrowsank">
          <img onClick={props.visibility} className="back" src={back} alt="" />
          <div className="colmain">
            <div className="firstrow2">
              <div className="rowbill">
                <>
                  <div className="mb-2">
                    <span className="subheadsank">{t("Rojkird.filters.date")}</span>
                    <input
                      onKeyDown={(e) => handleEnterKey(e, 0)}
                      ref={(ref) => (inputRefs.current[0] = ref)}
                      type="date"
                      className="form-control"
                      autoComplete="off"
                      id="date1"
                      name="date1"
                      value={input.date1}
                      onChange={handleChange}
                    />
                  </div>

                  <span className="subheadbill">{t("Rojkird.filters.to")}</span>

                  <div className="mb-2">
                    <span className="subheadsank">{t("Rojkird.filters.date")}</span>
                    <input
                      disabled
                      onKeyDown={(e) => handleEnterKey(e, 1)}
                      ref={(ref) => (inputRefs.current[1] = ref)}
                      type="date"
                      className="form-control"
                      autoComplete="off"
                      id="date2"
                      name="date2"
                      value={input.date2}
                      onChange={handleChange}
                    />
                  </div>
                </>

                <div className="mb-2">
                  {wait ? (
                    <button ref={(ref) => (inputRefs.current[4] = ref)} type="submit" id="show" className="btn btn-primary mx-1 sanksmall">
                      {t("Rojkird.buttons.loading")}
                    </button>
                  ) : (
                    <button
                      onClick={getrojkird}
                      ref={(ref) => (inputRefs.current[4] = ref)}
                      type="submit"
                      id="show"
                      className="btn btn-primary mx-1 sanksmall"
                    >
                      {t("Rojkird.buttons.viewReport")}
                    </button>
                  )}

                  <button
                    onClick={showprint}
                    ref={(ref) => (inputRefs.current[4] = ref)}
                    type="submit"
                    id="print"
                    className="btn btn-primary mx-1 sanksmall"
                  >
                    {t("Rojkird.buttons.print")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="firstrow2">
          <div className="table-containerbill">
            <div style={{ display: "flex" }}>
              {/* Positive Side */}
              <div style={{ width: "50%", paddingRight: "0%" }}>
                <table id="myTablebill" className="table table-bordered">
                  <thead>
                    <tr>
                      <th className="thlarge">{t("Rojkird.table.creditSide")}</th>
                      <th className="thsmall">{t("Rojkird.table.subAmount")}</th>
                      <th className="thsmall">{t("Rojkird.table.totalAmount")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {posGroupsFilled.map((group, gIndex) => (
                      <React.Fragment key={`pos-group-${gIndex}`}>
                        {group.head && (
                          <tr style={{ backgroundColor: "#eee", fontWeight: "bold" }}>
                            <td className="thsmallnavelefttale" colSpan="2">
                              {group.head}
                            </td>
                            <td className="thsmallright">{group.total.toFixed(2)}</td>
                          </tr>
                        )}

                        {group.records.map((rec, rIndex) => (
                          <tr key={`pos-group-${gIndex}-row-${rIndex}`}>
                            <td className="thsmallcust">
                              {rec.positive_kno ? `${rec.positive_kno} : ${rec.positive_name}` : ""}
                            </td>
                            <td className="thsmallcust">
                              {rec.positive_amount ? parseFloat(rec.positive_amount).toFixed(2) : ""}
                            </td>
                            <td className="thsmallcust">-</td>
                          </tr>
                        ))}
                      </React.Fragment>
                    ))}
                  </tbody>

                  <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                    <td className="thsmallnavelefttalegreen">{t("Rojkird.table.sum")}</td>
                    <td className="thsmallgreen2">-</td>
                    <td className="thsmallgreen2">{grandPosTotal.toFixed(2)}</td>
                  </tr>

                  <tfoot>
                    <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                      <td className="thsmallnavelefttalegray">{t("Rojkird.table.totalCredit")}</td>
                      <td className="thsmallgreen2right">-</td>
                      <td className="thsmallgreen2right">{grandPosTotal.toFixed(2)}</td>
                    </tr>

                    <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                      <td className="thsmallnavelefttalegray">{t("Rojkird.table.openingBalance")}</td>
                      <td className="thsmallgreen2right">-</td>
                      <td className="thsmallgreen2right">{grandOpeningTotal.toFixed(2)}</td>
                    </tr>

                    <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                      <td className="thsmallnavelefttalegray">{t("Rojkird.table.totalAmountLabel")}</td>
                      <td className="thsmallgreen2right">-</td>
                      <td className="thsmallgreen2right">
                        {parseFloat(parseFloat(grandPosTotal) + parseFloat(grandOpeningTotal)).toFixed(2)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* Negative Side */}
              <div style={{ width: "50%", paddingLeft: "0%" }}>
                <table id="myTablebill" className="table table-bordered">
                  <thead>
                    <tr>
                      <th className="thlarge">{t("Rojkird.table.expenseSide")}</th>
                      <th className="thsmall">{t("Rojkird.table.subAmount")}</th>
                      <th className="thsmall">{t("Rojkird.table.totalAmount")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {negGroupsFilled.map((group, gIndex) => (
                      <React.Fragment key={`neg-group-${gIndex}`}>
                        {group.head && (
                          <tr style={{ backgroundColor: "#eee", fontWeight: "bold" }}>
                            <td className="thsmallnavelefttale" colSpan="2">
                              {group.head}
                            </td>
                            <td className="thsmallright">{group.total.toFixed(2)}</td>
                          </tr>
                        )}

                        {group.records.map((rec, rIndex) => (
                          <tr key={`neg-group-${gIndex}-row-${rIndex}`}>
                            <td className="thsmallcust">
                              {rec.negative_kno ? `${rec.negative_kno} : ${rec.negative_name}` : ""}
                            </td>
                            <td className="thsmallcust">
                              {rec.negative_amount ? parseFloat(rec.negative_amount).toFixed(2) : ""}
                            </td>
                            <td className="thsmallcust">-</td>
                          </tr>
                        ))}
                      </React.Fragment>
                    ))}
                  </tbody>

                  <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                    <td className="thsmallnavelefttalegreen">{t("Rojkird.table.sum")}</td>
                    <td className="thsmallgreen2">-</td>
                    <td className="thsmallgreen2">{grandNegTotal.toFixed(2)}</td>
                  </tr>

                  <tfoot>
                    <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                      <td className="thsmallnavelefttalegray">{t("Rojkird.table.totalExpense")}</td>
                      <td className="thsmallgreen2right">-</td>
                      <td className="thsmallgreen2right">{grandNegTotal.toFixed(2)}</td>
                    </tr>

                    <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                      <td className="thsmallnavelefttalegray">{t("Rojkird.table.closingBalance")}</td>
                      <td className="thsmallgreen2right">-</td>
                      <td className="thsmallgreen2right">{grandClosingTotal.toFixed(2)}</td>
                    </tr>

                    <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                      <td className="thsmallnavelefttalegray">{t("Rojkird.table.totalAmountLabel")}</td>
                      <td className="thsmallgreen2right">-</td>
                      <td className="thsmallgreen2right">
                        {parseFloat(parseFloat(grandNegTotal) + parseFloat(grandClosingTotal)).toFixed(2)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Rojkird;
